import { I18nDictionary } from '@/components/i18n/lang-context'

export interface RealEstatePartner {
  id: string
  name: string
  logo: string
  logob?: string
  logoW: number
  logoH: number
  website: {
    fr: string
    en: string
  }
  email: string
  phone: string
  location: {
    fr: string
    en: string
  }
  backgroundImages: string[]
  description?: I18nDictionary
}

export const REAL_ESTATE_PARTNERS: RealEstatePartner[] = [
  {
    id: 'chabert',
    name: 'Chabert Group',
    logo: '/partners/chabert-group/chabert-group-logo.jpg',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://chabertgroup.com/fr/',
      en: 'https://chabertgroup.com/en/'
    },
    email: 'isabelle@chabertgroup.com',
    phone: '+33 6 50 34 99 01',
    location: {
      fr: 'Villefranche-sur-Mer',
      en: 'Villefranche-sur-Mer'
    },
    backgroundImages: [
      '/partners/chabert-group/chabert-group-1.png',
      '/partners/chabert-group/chabert-group-2.png',
      '/partners/chabert-group/chabert-group-3.png'
    ],
    description: {
      fr: 'Une agence familiale mère-fille au coeur de la Riviera',
      en: 'A mother-daughter agency in the heart of the Riviera'
    }
  },
  {
    id: 'emilegarcin',
    name: 'Emile Garcin Propriétés',
    logo: '/partners/emile-garcin/emile-garcin-logo.jpg',
    logob: '',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.emilegarcin.com/fr/',
      en: 'https://www.emilegarcin.com/en/'
    },
    email: '',
    phone: '',
    location: {
      fr: '24 agences dans toute la France',
      en: '24 agencies throughout France'
    },
    backgroundImages: [
      '/partners/emile-garcin/emile-garcin-1.jpg',
      '/partners/emile-garcin/emile-garcin-2.jpg',
      '/partners/emile-garcin/emile-garcin-3.jpg'
    ],
    description: {
      fr: 'L\'immobilier de caractère',
      en: 'Authentic Real Estate'
    }
  },
  {
    id: 'rivieraprestige',
    name: 'Riviera Prestige',
    logo: '/partners/riviera-prestige/riviera-prestige-logo.jpg',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.rivieraprestige.fr/fr/',
      en: 'https://www.rivieraprestige.fr/en/'
    },
    email: 'contact@rivieraprestige.fr',
    phone: '+33 6 77 77 70 80',
    location: {
      fr: 'Cannes',
      en: 'Cannes'
    },
    backgroundImages: [
      '/partners/riviera-prestige/riviera-prestige-1.jpg',
      '/partners/riviera-prestige/riviera-prestige-2.jpg',
      '/partners/riviera-prestige/riviera-prestige-3.jpg'
    ],
    description: {
      fr: '',
      en: ''
    }
  },
  {
    id: 'cannisimmo',
    name: 'CannisImmo',
    logo: '/partners/cannisimmo/cannissimo-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://cannisimmo.com/fr/',
      en: 'https://cannisimmo.com/en/'
    },
    email: 'info@cannisimmo.com',
    phone: '+33 4 92 19 62 55',
    location: {
      fr: 'Cannes Forville – Bocca Sud – Mandelieu',
      en: 'Cannes Forville – Bocca Sud – Mandelieu'
    },
    backgroundImages: [
      '/partners/cannisimmo/cannissimo-1.jpeg',
      '/partners/cannisimmo/cannissimo-2.jpeg',
      '/partners/cannisimmo/cannissimo-3.jpeg'
    ],
    description: {
      fr: 'Votre Confiance, Notre Réussite !',
      en: 'Your Trust, Our Success!'
    }
  },
  {
    id: 'impact',
    name: 'Impact',
    logo: '/partners/impact/impact-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://cannes-impact.com/fr/',
      en: 'https://cannes-impact.com/en/'
    },
    email: 'sales@cannes-impact.com',
    phone: '+33 4 93 30 13 13',
    location: {
      fr: 'Cannes',
      en: 'Cannes'
    },
    backgroundImages: [
      '/partners/impact/impact-1.jpg',
      '/partners/impact/impact-2.jpg',
      '/partners/impact/impact-3.jpg'
    ],
    description: {
      fr: 'Spécialiste des emplacements d\'exception depuis 1958',
      en: 'Experts in premium locations since 1958'
    }
  },
  {
    id: 'magrey',
    name: 'Magrey & Sons',
    logo: '/partners/magrey-and-sons/magrey-and-sons-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.magrey.fr/',
      en: 'https://www.magrey.com/'
    },
    email: 'cannes@magrey.com',
    phone: '+33 4 92 98 98 22',
    location: {
      fr: 'Cannes – Mougins',
      en: 'Cannes – Mougins'
    },
    backgroundImages: [
      '/partners/magrey-and-sons/magrey-and-sons-1.jpg',
      '/partners/magrey-and-sons/magrey-and-sons-2.jpg',
      '/partners/magrey-and-sons/magrey-and-sons-3.jpg'
    ],
    description: {
      fr: 'L\'art de vivre by Magrey & Sons',
      en: 'Discover the lifestyle'
    }
  },
  {
    id: 'intuition',
    name: 'Intuition',
    logo: '/partners/intuition/intuition-logo.jpg',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://intuition.immo/fr/',
      en: 'https://intuition.immo/en/'
    },
    email: 'contact@intuition.immo',
    phone: '+33 4 93 39 50 80',
    location: {
      fr: 'Cannes',
      en: 'Cannes'
    },
    backgroundImages: [
      '/partners/intuition/intuition-1.jpg',
      '/partners/intuition/intuition-2.jpg',
      '/partners/intuition/intuition-3.jpg'
    ],
    description: {
      fr: 'Une agence indépendante et à taille humaine',
      en: 'An independent, people-focused agency'
    }
  },
  {
    id: 'marcle',
    name: 'Marclé',
    logo: '/partners/marcle/marcle-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://marcleimmo.fr/fr/',
      en: 'https://marcleimmo.fr/en/'
    },
    email: 'contact@marcleimmo.fr',
    phone: '+33 4 93 39 00 64',
    location: {
      fr: 'Cannes',
      en: 'Cannes'
    },
    backgroundImages: [
      '/partners/marcle/marcle-1.jpg',
      '/partners/marcle/marcle-2.jpg',
      '/partners/marcle/marcle-3.jpg'
    ],
    description: {
      fr: '',
      en: ''
    }
  }
]
